import {WILDCARD} from '../consts/route/routePaths';
import history from './history';

const forwardTo = (location: string): void => history.getHistory().push(location);

const forwardToNotFound = (): void => history.getHistory().push(WILDCARD);

const goBack = (): void => history.getHistory().goBack();

const reload = (): void => window.location.reload();

const replace = (location: string): void => history.getHistory().replace(location);

const redirect = (location: string): void => {
    window.location.href = location;
};

const blankLinkOpen = (url: string): void => {
    window.open(url, '_blank');
};

export default {
    blankLinkOpen,
    forwardTo,
    forwardToNotFound,
    goBack,
    redirect,
    reload,
    replace,
};
